
export enum ProgramType {
  LowBack = 'lbp',
  Shoulder = 'shoulder',
  Knee = 'knee',
  Hip = 'hip',
  Neck = 'neck',
}
